module.exports = __webpack_public_path__ + "068e0709000fffce27b77bbc0cc0bb7c.png";